export default "<span>{{ label }}</span>"